import {
  AssetDocumentSectionProps as SharedAssetDocumentSectionProps,
  PendingDocumentMove as SharedPendingDocumentMove,
} from "@shared";

import { PendingDocumentMove } from "@/common/components/layout/components/dropzone/dnd/DropZoneDnd.types";
import { getAssetInventoryUploadArea } from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/asset-inventory-tab/assetInventoryUploadAreas";
import { AssetDocumentSection } from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/asset-inventory-tab/components/asset-document-section/AssetDocumentSection";

// The shared PendingDocumentMove carries opaque string zone ids and the trimmed document shape;
// every value in this app's pipeline originates from DocumentGroup zones and full document
// responses (panel drags or the asset areas), so narrowing back is safe by construction.
const toAppMoves = (moves: SharedPendingDocumentMove[]) => moves as PendingDocumentMove[];

/**
 * Adapts the shared AssetDocumentSection slot props (zone id, trimmed move shape) to this app's
 * upload-area registry and DnD types — injected into the shared client-file views through the
 * documentDnd slice.
 */
export function SlotAssetDocumentSection({
  zone,
  documentMoves,
  onAddMove,
  onCancelMove,
  ...rest
}: SharedAssetDocumentSectionProps) {
  return (
    <AssetDocumentSection
      {...rest}
      area={getAssetInventoryUploadArea(zone)}
      documentMoves={toAppMoves(documentMoves)}
      onAddMove={onAddMove}
      onCancelMove={onCancelMove}
    />
  );
}
